import React from 'react';
import { Box } from '@mui/material';
import { GeneralDialogComponentProps } from '../../../models/GeneralDialogProps';

export const ShippingDialogContent: React.FC<GeneralDialogComponentProps> = (
    props
) => {
    return (
        <Box sx={{ paddingTop: '20px' }}>
            <Box>Keress bizalommal bennünket:</Box>
            <Box>+36 30 265 8491</Box>
            <Box> +36 30 222 5036</Box>
        </Box>
    );
};
